<template>
  <div class="bg">
    <iframe :src="url1" id="ifrm" scrolling="no" frameborder="0"></iframe>
  </div>
</template>
<script>
import util from "@/utils/util.js";
export default {
  data() {
    return {
      deviceNo:"",
      url1: '',
    }
  },
  mounted() {
    //获取
    this.deviceNo = this.$route.query.deviceNo;
    this.getReport();
  },
  methods: {
    getReport(){

      this.$postForm(
        "dmc/mattress/reportUrl",
        {
          sn: this.deviceNo,
          date: util.formatDate.getBeforeDay()
        }).then(res => {
          console.log(res)
          this.url1 = res.result;
        });
    }
  }
};
</script>
  
<style lang="scss" scoped>
.bg {
  background: white;
  width: 100%;
  height: 100%;
  overflow-y: scroll; //必须有这个，否则ios无法滚动。
  -webkit-overflow-scrolling: touch; // ios滚动卡顿的问题。
}

iframe {
  width: 50%;
  height: 760%;
}
</style>